import { useTranslation } from 'react-i18next';
import { StatusBadge } from '../../../components/StatusBadge';
import type { AccountStatus } from '../utils';

const STATUS_COLOURS: Record<
  AccountStatus,
  { backgroundColor: string; color: string }
> = {
  active: {
    backgroundColor: 'var(--color-scifree-teal)',
    color: 'var(--color-light-greyish-blue)',
  },
  trial: {
    backgroundColor: 'var(--color-very-pale-orange)',
    color: 'var(--color-deep-ocean-blue)',
  },
  disabled: {
    backgroundColor: 'var(--color-grey-red)',
    color: 'var(--color-light-greyish-blue)',
  },
};

export const AccountStatusBadge = ({ status }: { status: AccountStatus }) => {
  const { t } = useTranslation();
  return (
    <StatusBadge
      badgeContent={t(`accounts.statusValues.${status}`)}
      sx={{
        // A different key from StatusBadge's own '& .MuiBadge-badge', declared
        // after it, so these colours replace the severity's.
        '& > .MuiBadge-badge': {
          position: 'static',
          transform: 'none',
          height: 'auto',
          minHeight: 22,
          px: 12,
          py: 8,
          borderRadius: 4,
          fontSize: 12,
          fontWeight: 700,
          whiteSpace: 'nowrap',
          ...STATUS_COLOURS[status],
          border: `1px solid ${STATUS_COLOURS[status].color}`,
        },
      }}
    />
  );
};
